class HeroCarousel {
  constructor(element) {
    this.carousel = element;
    this.wrapper = element.querySelector('.hero-carousel__wrapper');
    this.slides = Array.from(this.wrapper.children);
    this.controls = element.querySelector('.hero-carousel__controls');
    this.dots = element.querySelector('.hero-carousel__dots');
    this.currentIndex = 0;
    this.autoplayInterval = null;
    
    this.init();
  }

  init() {
    this.createDots();
    this.setupParallax();
    this.setupControls();
    this.startAutoplay();
    this.setupTouchEvents();
  }

  createDots() {
    this.slides.forEach((_, index) => {
      const dot = document.createElement('button');
      dot.classList.add('hero-carousel__dot');
      dot.addEventListener('click', () => this.goToSlide(index));
      this.dots.appendChild(dot);
    });
    this.updateDots();
  }

  setupParallax() {
    window.addEventListener('scroll', () => {
      this.slides.forEach(slide => {
        const parallax = slide.querySelector('.parallax');
        if (parallax) {
          const rect = slide.getBoundingClientRect();
          const scrollPercent = rect.top / window.innerHeight;
          parallax.style.transform = `translateY(${scrollPercent * 50}px)`;
        }
      });
    });
  }

  setupControls() {
    const prev = this.controls.querySelector('.hero-carousel__prev');
    const next = this.controls.querySelector('.hero-carousel__next');

    prev.addEventListener('click', () => this.prevSlide());
    next.addEventListener('click', () => this.nextSlide());
  }

  setupTouchEvents() {
    let startX;
    let isDragging = false;

    this.wrapper.addEventListener('touchstart', (e) => {
      startX = e.touches[0].clientX;
      isDragging = true;
    });

    this.wrapper.addEventListener('touchmove', (e) => {
      if (!isDragging) return;
      const currentX = e.touches[0].clientX;
      const diff = startX - currentX;

      if (Math.abs(diff) > 50) {
        if (diff > 0) this.nextSlide();
        else this.prevSlide();
        isDragging = false;
      }
    });

    this.wrapper.addEventListener('touchend', () => {
      isDragging = false;
    });
  }

  goToSlide(index) {
    this.currentIndex = index;
    this.wrapper.style.transform = `translateX(-${index * 100}%)`;
    this.updateDots();
    this.resetAutoplay();
  }

  prevSlide() {
    this.currentIndex = (this.currentIndex - 1 + this.slides.length) % this.slides.length;
    this.goToSlide(this.currentIndex);
  }

  nextSlide() {
    this.currentIndex = (this.currentIndex + 1) % this.slides.length;
    this.goToSlide(this.currentIndex);
  }

  updateDots() {
    const dots = this.dots.querySelectorAll('.hero-carousel__dot');
    dots.forEach((dot, index) => {
      dot.classList.toggle('active', index === this.currentIndex);
    });
  }

  startAutoplay() {
    this.autoplayInterval = setInterval(() => this.nextSlide(), 5000);
  }

  resetAutoplay() {
    clearInterval(this.autoplayInterval);
    this.startAutoplay();
  }
}

// Inicialización del carrusel y otras funcionalidades
document.addEventListener('DOMContentLoaded', () => {
  // Inicializar hero carousel
  const heroCarousels = document.querySelectorAll('.hero-carousel');
  heroCarousels.forEach(carousel => new HeroCarousel(carousel));

  // Inicializar animaciones al hacer scroll
  const animateElements = document.querySelectorAll(
    '.animate--fade-in, .animate--slide-in, .animate--fade-up'
  );

  const observerCallback = (entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.style.animationDelay = '0.2s';
        entry.target.style.animationPlayState = 'running';
      }
    });
  };

  const observer = new IntersectionObserver(observerCallback, {
    threshold: 0.1
  });

  animateElements.forEach(element => {
    element.style.animationPlayState = 'paused';
    observer.observe(element);
  });
});